var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as App from '../../app';
import { Component } from '../../lib/dom';
import './Coins.less';
var Coins = /** @class */ (function (_super) {
    __extends(Coins, _super);
    function Coins(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'Coins';
        _this.coins = App.storage.get().coins;
        _this.el = _this.DIV({ className: '&', onClick: _this.props.onClick }, [
            _this.DIV('&__dollar'),
            (_this.balance = _this.DIV('&__balance', [String(_this.coins)])),
            _this.DIV('&__button'),
        ]);
        App.storage.on('write', function (_a) {
            var coins = _a.coins;
            if (_this.coins !== coins) {
                var delta_1 = coins - _this.coins;
                _this.balance.html(String(coins));
                _this.addAnimation(delta_1);
                _this.coins = coins;
                setTimeout(function () { return App.storage.inc(delta_1 > 0 ? 'receivedCoinsCounter' : 'usedCoinsCounter', Math.abs(delta_1)); }, 1);
            }
        });
        return _this;
    }
    Coins.prototype.addAnimation = function (delta) {
        var _this = this;
        var div = this.DIV('&__animation', [delta > 0 ? "+".concat(delta) : String(delta)]);
        this.el.appendChild(div);
        setTimeout(function () { return div.toggleClassName("".concat(_this.name, "__animation_").concat(delta > 0 ? 'top' : 'bottom'), true); }, 100);
        setTimeout(function () { return _this.el.removeChild(div); }, 1000);
    };
    return Coins;
}(Component));
export { Coins };
